import { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Modal, Table } from 'antd';
import findIndex from 'lodash.findindex';
import cloneDeep from 'lodash.clonedeep';
import { I18n } from 'react-redux-i18n';
import { AppState } from '../../../../reducers';
import { getReportStorage, getReportStorageDetails } from '../../ReportActions';
import ReportStorageDetailsData from './ReportStorageDetailsData';

function ReportAccountData({ data, filter, total_count, is_mobile, getReportStorage, getReportStorageDetails }: any) {
  const [openDetailReport, setOpenDetailReport] = useState(false)
  const onChange = useCallback(
    (pagination: any) => {
      const _filter: any = cloneDeep(filter);
      const indexLimit = findIndex(filter, ['attribute', 'limit']);
      const indexSkip = findIndex(filter, ['attribute', 'skip']);
      if (indexLimit > -1) {
        const skip = parseFloat(pagination.current) * parseFloat(_filter[indexLimit].value) - _filter[indexLimit].value;
        indexSkip > -1 ? (_filter[indexSkip].value = skip) : _filter.push({ attribute: 'skip', value: skip });
      }

      getReportStorage(_filter);
    },
    [filter, getReportStorage]
  );

  const limit = useMemo(() => (filter.find((item: any) => item.attribute === 'limit') || { value: 0 }).value, [filter]);

  let pagination = useMemo(
    () =>
      total_count <= limit
        ? false
        : {
            total: total_count,
            pageSize: limit,
          },
    [limit, total_count]
  );

  const columns = useMemo(
    () => [
      {
        title: I18n.t('report.Product'),
        dataIndex: 'title',
        key: 'title',
        sorter: (a: any, b: any) => ('' + a.title).localeCompare(b.title),
      },
      {
        title: I18n.t('report.Count'),
        dataIndex: 'count',
        key: 'count',
        align: 'right' as any,
        width: '15%',
        sorter: (a: any, b: any) => a.count - b.count,
      },
      {
        title: I18n.t('report.AvgPrice'),
        dataIndex: 'price',
        key: 'price',
        align: 'right' as any,
        width: '15%',
        render: (_: any, item: any) => {
          return item.count ? (item.total / item.count).formatNumber() : '';
        },
        sorter: (a: any, b: any) => {
          const aAvgPrice = a.count ? a.total / a.count : 0;
          const bAvgPrice = b.count ? b.total / b.count : 0;
          return aAvgPrice - bAvgPrice;
        },
      },
      {
        title: I18n.t('report.Total'),
        dataIndex: 'total',
        key: 'total',
        align: 'right' as any,
        width: '15%',
        render: (total: any) => {
          return total ? total.formatNumber() : '';
        },
        sorter: (a: any, b: any) => a.total - b.total,
      },
    ],
    []
  );

  const total = useMemo(
    () => (Array.isArray(data) ? data.reduce((_sum, item) => _sum + (item.total || 0), 0) : 0),
    [data]
  );

  return (<>
    <Modal
      title={I18n.t('report.Product report')}
      open={openDetailReport}
      onCancel={() => { setOpenDetailReport(false); }}
      footer={false}
      width={is_mobile ? '100%' : '90%'}
      // onCancel={this.handleCancel}
    >
      <ReportStorageDetailsData />
    </Modal>
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      onChange={onChange}
      bordered
      pagination={pagination}
      showSorterTooltip={false}
      sortDirections={['ascend', 'descend']}
      footer={() => (
        <div>
          {I18n.t('bill.Summary Total')}: <strong>{total.formatNumber()}</strong>
        </div>
      )}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event: any) => {
            getReportStorageDetails([
              ...filter,
              { attribute: 'product_id', value: record.id },
            ]);
            setOpenDetailReport(true);
          },
        };
      }}
    />
  </>);
}

const mapStateToProps = (state: AppState) => ({
  total_count: state.report.total_count,
  data: state.report.report,
  filter: state.report.filter,
  accounts: state.started_data.accounts,
  is_mobile: state.auth.is_mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getReportStorage,
      getReportStorageDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReportAccountData);
